module.exports = __webpack_public_path__ + "static/1368875089-wide.b7278125.jpg";